<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogTableVisible"
    :before-close="handleClose"
    width="600px"
  >
    <div class="table-box">
      <el-table
        height="100%"
        :data="current ? current.users || [] : []"
        border
        highlight-current-row
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
        />
        <el-table-column
          prop="companyName"
          label="分子公司"
        />
        <el-table-column
          prop="bizName"
          label="人员"
        />
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    current: {
      type: Object,
      default: () => ({}),
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    dialogTableVisible() {
      return this.isShow;
    },
  },
  methods: {
    handleClose() {
      this.$emit('close', false);
      this.dialogFormVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
 .table-box {
    height: 405px;
  }
</style>
